require('./dist/select.js');
module.exports = 'ui.select';



//////////////////
// WEBPACK FOOTER
// ../~/ui-select/index.js
// module id = 93
// module chunks = 1